import api from './api';

// SPEC F3 — kadro talebine bağlı işe alım maliyet kayıtları.
// Okuma: AT.Write veya kadronun HM'i. Yazma: AT.Write.
const base = (requisitionId) => `/v1/ats-requisitions/${encodeURIComponent(requisitionId)}/costs`;

export const listRecruitingCosts = (requisitionId) => api.get(base(requisitionId));
export const createRecruitingCost = (requisitionId, data) => api.post(base(requisitionId), data);
export const updateRecruitingCost = (requisitionId, costId, data) =>
  api.put(`${base(requisitionId)}/${encodeURIComponent(costId)}`, data);
export const deleteRecruitingCost = (requisitionId, costId) =>
  api.delete(`${base(requisitionId)}/${encodeURIComponent(costId)}`);
